// extracted by mini-css-extract-plugin
module.exports = {"primary":"D_S","secondary":"D_T"};